// extracted by mini-css-extract-plugin
export default {"root":"SignIn_root__+txC8","inpContainer":"SignIn_inpContainer__RExjJ","buttonsContainer":"SignIn_buttonsContainer__pu2Se","orange":"SignIn_orange__lMxc9"};